const $50e72c138a2053f6$export$e575061ef2a070eb = document.querySelector("#counter");


function $b290253f19664082$var$get_random_int(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
}
let $b290253f19664082$var$count_to = $b290253f19664082$var$get_random_int(5, 20);
let $b290253f19664082$var$count_value = 0;
function $b290253f19664082$export$11b96d1c93d4b553() {
    if (0, $50e72c138a2053f6$export$e575061ef2a070eb) (0, $50e72c138a2053f6$export$e575061ef2a070eb).textContent = $b290253f19664082$var$count_value.toString();
    $b290253f19664082$var$count_value++;
    if ($b290253f19664082$var$count_value == $b290253f19664082$var$count_to) {
        $b290253f19664082$var$count_value = 0;
        $b290253f19664082$var$count_to = $b290253f19664082$var$get_random_int(5, 20);
        console.debug(`counting until: ${$b290253f19664082$var$count_to}`);
    }
    setTimeout($b290253f19664082$export$11b96d1c93d4b553, 1000);
}


(0, $b290253f19664082$export$11b96d1c93d4b553)();


//# sourceMappingURL=index.d24454a4.js.map
